import { createContext } from "react";
import { Currency } from "../../../../types/global";

// @ts-ignore
export const CurrencyContext = createContext<Currency>("")

export const CurrencyControllerContext = createContext<{
    set: (currency: Currency) => any
    // @ts-ignore
}>(undefined)